<template>
  <div
    :class="$style.policiesContainer"
    data-test-id="ConfiguredPolicies_container"
  >
    <div
      v-if="hasPolicies"
    >
      <div
        v-for="policy in tableData"
        :key="policy.name"
        :class="$style.policy"
        data-test-id="ConfiguredPolicies_item"
      >
        <div
          :class="$style.policyNameContainer"
          :title="policy.name"
        >
          <div :class="$style.policyOsIcon">
            <Icon
              :class="$style.icon"
              :icon="systemOsIcon(policy)"
              inline
              :scale="2"
              :showLabel="false"
            />
          </div>
          <div :class="$style.policyName">
            <ParagraphBody
              :hasMargin="false"
              :title="policy.name"
            >
              {{ policy.name }}
            </ParagraphBody>
            <ParagraphBody
              bodySize="small"
              :hasMargin="false"
              weight="light"
            >
              {{ templateDisplayName(policy) }}
            </ParagraphBody>
          </div>
        </div>
        <div :class="$style.policyDescription">
          <ParagraphBody :title="templateDescription(policy)">
            {{ templateDescription(policy) }}
          </ParagraphBody>
        </div>
      </div>
    </div>
    <div v-else>
      <ParagraphBody
        bodySize="large"
        :class="$style.noPolicies"
      >
        No Policies Within This Group
      </ParagraphBody>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { ItemTableConsts } from 'client/util/Constants';
import stripHtml from 'client/util/StripHtml';

const { parentOSType } = ItemTableConsts;
const {
  darwin,
  ios,
  linux,
  windows,
} = parentOSType;

export default {
  name: 'ConfiguredPolicies',

  components: {
    Icon,
    ParagraphBody,
  },

  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },

  computed: {
    hasPolicies() {
      return this.tableData.length;
    },
  },

  methods: {
    systemOsIcon(policy) {
      const type = policy.type || policy.template.osMetaFamily;

      const iconMap = {
        [linux]: 'linux',
        [windows]: 'windows',
        [darwin]: 'apple',
        [ios]: 'ios',
      };
      return iconMap[type] || '';
    },

    templateDescription(policy) {
      return policy.template ? stripHtml(policy.template.description) : '';
    },

    templateDisplayName(policy) {
      return policy.template ? policy.template.displayName : '';
    },
  },

};
</script>

<style module scoped>

.policiesContainer {
  overflow-x: hidden;
  overflow-y: auto;
}

.noPolicies {
  text-align: center;
}

.policy {
  display: flex;
  gap: var(--jc-spacer);
  justify-content: space-between;
}

.policy:not(:first-child) {
  padding-top: var(--jc-spacer);
}

.policy:not(:last-child) {
  border-bottom: var(--jc-border);
  padding-bottom: var(--jc-spacer);
}

.policyNameContainer {
  display: flex;
  flex: 0 0 20em;
  margin-top: var(--jc-spacer-small);
}

.policyOsIcon {
  flex: 0 0 3.2em;
}

.policyName {
  flex: 1;
  margin-left: var(--jc-spacer);
  min-width: 0;
}

.policyName p {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.policyDescription {
  flex: 1;
}

.policyDescription p {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  margin-top: var(--jc-spacer-small);
  overflow: hidden;
}
</style>
